import { definePreset } from '@primeuix/themes';
import aura from '@primeuix/themes/aura';

export const primengTheme = definePreset(aura, {
  semantic: {
    primary: {
      50: '#EEF2FF',
      100: '#DDE5FA',
      200: '#B9C2DB',
      300: '#8A9ACB',
      400: '#4A67AF',
      500: '#1E3A8A',
      600: '#2B4DAE',
      700: '#2952CC',
      800: '#142760',
      900: '#0F1F4A',
      950: '#0A1535'
    },
    colorScheme: {
      light: {
        primary: {
          color: '#1E3A8A',
          inverseColor: '#ffffff',
          hoverColor: '#2B4DAE',
          activeColor: '#2952CC'
        }
      }
    }
  }
});
